"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_location_constraint_middleware = require("@aws-sdk/location-constraint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var CreateBucket_1 = require("../model/CreateBucket");
var CreateBucketCommand = /** @class */ (function () {
    function CreateBucketCommand(input) {
        this.input = input;
        this.model = CreateBucket_1.CreateBucket;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    CreateBucketCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_location_constraint_middleware.locationConstraintMiddleware(configuration.region), {
            step: "initialize",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return CreateBucketCommand;
}());
exports.CreateBucketCommand = CreateBucketCommand;
//# sourceMappingURL=CreateBucketCommand.js.map